import { isNil } from 'es-toolkit';
import { House } from 'lucide-react';

import { greyIconsColor } from '@savvy/deprecated-shared/theme';
import { mapIconColorToPalette } from '@savvy/deprecated-shared/theme/utils';

import type { XIconProps } from './types';
import { DEFAULT_ICON_SIZE } from './types';

export function XHome({ color, size = DEFAULT_ICON_SIZE, style, onClick }: XIconProps) {
  let mappedColor = greyIconsColor;
  if (!isNil(color)) {
    mappedColor = mapIconColorToPalette[color] ?? color;
  }
  return <House onClick={onClick} style={{ color: mappedColor, height: size, width: size, ...style }} />;
}
